import {
  Component,
  Input,
  signal,
  TemplateRef,
  ContentChild,
} from '@angular/core';
import { BASIC_IMPORTS } from '../../../imports/common-imports';

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [BASIC_IMPORTS],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
})
export class TabComponent {
  @Input() label: string = '';
  @Input() flagColor: string = '';
  @Input() disabled: boolean = false;
  @ContentChild('tabHeader', { read: TemplateRef })
  headerTemplate?: TemplateRef<any>;
  isActive = signal(false);
}
